<!--  -->
<template>
<div class=''></div>
</template>

<script>
import { API_CONFIG, OAUTH2_CONFIG } from '@/page/config/base_config'
import { mapGetters } from 'vuex'
import { fetchlocalWebSetting } from '@/framework/util/util'
import microserviceRouter from '@/framework/router/microserviceRouter'
export default {
  computed: mapGetters(['website']),
  // import引入的组件需要注入到对象中才能使用
  methods: {
    cas: function() {
      let toUrl = this.$route.query.toUrl ? this.$route.query.toUrl : this.website.firstPage.value
      let thirdPartyName = this.$route.query.thirdPartyName ? this.$route.query.thirdPartyName : ''
      let paths = '/integrate/uaap/cas/to-cas-login?next=' + encodeURIComponent(toUrl) + '&thirdPartyName=' + thirdPartyName + '&frontUrl=' + encodeURIComponent(OAUTH2_CONFIG.FRONT_DEPLOYMENT_ADDRESS + '/casLogin')
      let method = 'GET'
      for (let i = 0; i < microserviceRouter.length; i++) {
        if (microserviceRouter[i][method] && new RegExp(microserviceRouter[i][method]).test(paths)) {
        // console.log('正则命中', paths)
          paths = `${microserviceRouter[i].basePath}${paths}`
          break
        }
      }
      window.location.href = API_CONFIG.API_BASE_URL + paths
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    fetchlocalWebSetting()
    this.cas()
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>
